import { getResponseMessage } from '@app/shared/utils/response-message.util';
import { Component, inject, OnInit, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { FilterItem } from '../../../../../../shared/components/api/models/filterItem.model';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { CategoriaService } from '@app/shared/components/api/services/categoria.service';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { forkJoin } from 'rxjs';
import { AdminDetalheCampanhaComponent } from '../admin-detalhe-campanha/admin-detalhe-campanha.component';
import { DrawerModule } from 'primeng/drawer';
import { Dialog } from 'primeng/dialog';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { InputNumber } from 'primeng/inputnumber';
import { Button } from 'primeng/button';
import { EstadoCampanhaENUM } from '@app/shared/components/api/models/estadoCampanha.enum';
import { SkeletonLoaderComponent } from '@app/shared/components/skeleton-loader/skeleton-loader.component';
import { CampanhaDestaqueService } from '@app/shared/components/api/services/campanha-destaque.service';
import { ProvinciaService } from '@app/shared/components/api/services/provincia.service';
import { Menu } from 'primeng/menu';
import { CardCampanhaDashAdminComponent } from '@app/shared/components/card-campanha-dash-admin/card-campanha-dash-admin.component';
import { Select } from 'primeng/select';
import { DocumentoService } from '@app/shared/components/api/services/documento.service';
import { SupenderCampanhaComponent } from '@app/shared/components/supender-campanha/supender-campanha.component';
import { RejeitarCampanhaComponent } from '@app/shared/components/rejeitar-campanha/rejeitar-campanha.component';
import { UtilizadoresService } from '@app/shared/components/api/services/utilizadores.service';
import { ApoioService } from '@app/shared/components/api/services/apoio.service';
import { UserService } from '@app/auth/services/user.service';
import { LoaderComponent } from '@app/shared/components/loader/loader.component';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';

@Component({
  selector: 'app-admin-lista-campanhas',
  imports: [
    SupenderCampanhaComponent,
    CommonModule,
    CardCampanhaDashAdminComponent,
    DataVoidComponent,
    PaginatorControlComponent,
    SearchBarComponent,
    AdminDetalheCampanhaComponent,
    DrawerModule,
    Dialog,
    Select,
    ReactiveFormsModule,
    Button,
    SkeletonLoaderComponent,
    MoneyPipe,
    RejeitarCampanhaComponent,
    InputNumber,
    LoaderComponent,
  ],
  standalone: true,
  providers: [
    CampanhaService,
    CategoriaService,
    EnumService,
    CampanhaDestaqueService,
    ProvinciaService,
    DocumentoService,
    UtilizadoresService,
    ApoioService,
    UserService,
  ],
  templateUrl: './admin-lista-campanhas.component.html',
  styleUrl: './admin-lista-campanhas.component.scss',
})
export class AdminListaCampanhasComponent implements OnInit {
  [x: string]: any;
  // injections
  private readonly campanhaService = inject(CampanhaService);
  private readonly categoriaService = inject(CategoriaService);
  private readonly enumService = inject(EnumService);
  private readonly fb = inject(FormBuilder);
  private readonly messageService = inject(MessageService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly campanhaDestaqueService = inject(CampanhaDestaqueService);
  private readonly provinciaService = inject(ProvinciaService);
  private readonly documentoService = inject(DocumentoService);
  private readonly apoioService = inject(ApoioService);
  private readonly userService = inject(UserService);
  private readonly utilizadorService = inject(UtilizadoresService);
  categoriaList: any[] = [];
  estadoCampanhaOptions: any[] = [];
  provinciaList: any[] = [];
  estadoApoioList: any[] = [];
  utilizadoresList: any[] = [];
  tipofinanciamentoList: any[] = [];
  visible: boolean = false;
  showRejeitCampanha: boolean = false;
  showDialogSuspend: boolean = false;
  showDialogApoioManual: boolean = false;
  loading: boolean = false;
  loadCampanhas: boolean = false;
  loadFilters: boolean = false;
  showModalFiter: boolean = false;
  IsrecompensaCampanha: boolean = false;
  campanha: any;
  campanhaID: any;
  campanhaSelecionada: any;
  recompensaSelecionada: any = null;
  isDepositoApoio: boolean = false;
  isTransferenciaApoio: boolean = false;
  currentFilters: any = {};
  pagination: Pagination<any> = new Pagination<any>();
  formFilter!: FormGroup;
  formApoioManual!: FormGroup;
  @Output() destaqueFilterSelected = new EventEmitter<void>();

  @Input() set estadoCampanhaFilter(estadoEnum: number | null | undefined) {
    if (estadoEnum !== undefined && estadoEnum !== null) {
      this.currentFilters = {
        ...this.currentFilters,
        EstadoCampanhaENUM: estadoEnum,
      };
    } else {
      const { EstadoCampanhaENUM, ...rest } = this.currentFilters;
      this.currentFilters = rest;
    }
    this.pagination.pageNumber = 1;
    this.getAllCampanhas();
  }

  activeList = [
    {
      label: 'Sim',
      value: true,
    },
    {
      label: 'Não',
      value: false,
    },
  ];

  typeApoioOptions = [
    {
      label: 'Depósito',
      value: 1,
    },
    {
      label: 'Transferência',
      value: 2,
    },
  ];

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'CategoriaId',
      options: this.categoriaList,
      placeholder: 'Sector',
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'ProvinciaID',
      options: this.provinciaList,
      placeholder: 'Provincia',
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoCampanhaENUM',
      options: this.estadoCampanhaOptions,
      placeholder: 'Seleccione o estado',
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'TipoFinanciamentoENUM',
      options: this.tipofinanciamentoList,
      placeholder: 'Seleccione o tipo de financiamento',
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'Destaque',
      options: [
        { label: 'Em Destaque', value: 'destaque' },
      ],
      placeholder: 'Destaque',
      optionLabel: 'label',
      optionValue: 'value',
    },
  ];

  ngOnInit(): void {
    this.getAllCampanhas();
    this.loadDropdowns();
    this.initForms();
    this.getAllUsers();
  }

  initForms() {
    this.formFilter = this.fb.group({
      ValorApoio: [null],
      EstadoApoioENUM: [null],
      Ativo: [null],
    });

    this.formApoioManual = this.fb.group({
      ValorApoio: [{ value: null, disabled: false }, Validators.required],
      TipoApoio: [null, Validators.required],
      utilizadorID: [null, Validators.required],
    });

    this.formApoioManual.get('TipoApoio')?.valueChanges.subscribe((value) => {
      if (value === 1) {
        this.isDepositoApoio = true;
        this.isTransferenciaApoio = false;
      } else if (value === 2) {
        this.isDepositoApoio = false;
        this.isTransferenciaApoio = true;
      } else {
        this.isDepositoApoio = false;
        this.isTransferenciaApoio = false;
      }
    });
  }

  getAllCampanhas(filters?: any) {
    this.loadCampanhas = true;
    const params = {
      ...this.currentFilters,
      ...filters,
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1,
      OrderBy: 'id desc',
    };

    this.campanhaService.list(params).subscribe({
      next: (res) => {
        this.pagination = new Pagination<any>().deserialize(res);
        this.loadCampanhas = false;
      },
      error: (err) => {
        console.error(err);
        this.loadCampanhas = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Falha',
          detail: 'Não foi possível carregar campanhas',
          life: 5000,
        });
      },
    });
  }

  loadDropdowns() {
    forkJoin({
      estadoCampanha: this.enumService.getAllEstadoCampanha(),
      estadoApoio: this.enumService.getAllEstadoApoio(),
      TipoFinanciamentoENUM: this.enumService.getAllTipoFinanciamento(),
      categoria: this.categoriaService.list({ pageSize: 100 }),
      provincia: this.provinciaService.list({ pageSize: 100 }),
    }).subscribe((response) => {
      // Enums
      if (response.estadoCampanha?.data) {
        this.estadoCampanhaOptions = Object.entries(
          response.estadoCampanha.data,
        ).map(([key, value]) => ({
          id: Number(key),
          label: value,
        }));
        this.filters[2].options = this.estadoCampanhaOptions;
      }
      if (response.estadoApoio?.data) {
        this.estadoApoioList = Object.entries(response.estadoApoio.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
      }
      if (response.TipoFinanciamentoENUM?.data) {
        this.tipofinanciamentoList = Object.entries(
          response.TipoFinanciamentoENUM.data,
        ).map(([key, value]) => ({
          id: Number(key),
          label: value,
        }));
        this.filters[3].options = this.tipofinanciamentoList;
      }
      // Listas comuns
      if (response.categoria?.data) {
        this.categoriaList = response.categoria.data.map((item: any) => ({
          label: item.descricao,
          value: item.id,
        }));
        this.filters[0].options = this.categoriaList;
      }
      if (response.provincia?.data) {
        this.provinciaList = response.provincia.data.map((item: any) => ({
          label: item.descricao,
          id: item.id,
        }));
        this.filters[1].options = this.provinciaList;
      }
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllCampanhas();
  }

  handleFormValueChange(event: any) {
    if (event?.Destaque === 'destaque') {
      this.destaqueFilterSelected.emit();
      return;
    }

    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([key, value]) => key !== 'Destaque' && value !== null && value !== undefined && value !== '',
      ),
    );

    this.currentFilters = filters; // guardar filtros ja aplicados
    this.getAllCampanhas();
  }

  // Acoes de menu
  verDetalhe(campanha: any) {
    this.campanha = campanha;
    this.visible = true;
  }

  isInvalidFilter(field: string): boolean {
    const control = this.formFilter.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  isInvalidApoio(field: string): boolean {
    const control = this.formApoioManual.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  getActionsByEstado(campanha: any): MenuItem[] {
    const baseActions: MenuItem[] = [
      {
        label: 'Ver detalhes',
        icon: 'pi pi-eye',
        command: (event) => {
          this.verDetalhe(campanha);
        },
      },
    ];

    switch (campanha.estadoCampanhaENUM) {
      case EstadoCampanhaENUM.Rascunho:
        return [
          ...baseActions,
          {
            label: 'Excluir rascunho',
            icon: 'pi pi-trash',
            command: () => this.excluirCampanha(campanha),
          },
        ];

      case EstadoCampanhaENUM.Pendente:
        return [
          ...baseActions,
          {
            label: 'Publicar campanha',
            icon: 'pi pi-arrow-up-right',
            command: () => this.publicarCampanha(campanha),
          },
          {
            label: 'Rejeitar publicação',
            icon: 'pi pi-times',
            command: () => this.showDialogRejeit(campanha),
          },
          {
            label: 'Voltar ao Rascunho',
            icon: 'pi pi-undo',
            command: () => this.ColocarCampanhaRascunho(campanha),
          },
        ];

      case EstadoCampanhaENUM.Publicado:
      case EstadoCampanhaENUM.EmCurso:
        return [
          ...baseActions,
          {
            label: 'Suspender campanha',
            icon: 'pi pi-pause',
            command: () => this.suspenderCampanha(campanha),
          },
          {
            label: 'Destacar Campanha',
            icon: 'pi pi-star',
            command: () => this.DestacarCampanha(campanha),
          },
          {
            label: 'Apoio Manual',
            icon: 'pi pi-plus-circle',
            command: () => this.openApoioManual(campanha),
          },
        ];

      case EstadoCampanhaENUM.Suspensa:
        return [
          ...baseActions,
          {
            label: 'Remover Suspensão',
            icon: 'pi pi-play',
            command: () => this.publicarCampanha(campanha),
          },
        ];

      case EstadoCampanhaENUM.Encerrada:
        return [
          ...baseActions,
          {
            label: 'Reembolsar Apoios',
            icon: 'pi pi-money-bill',
            command: () => this.reembolsarApoios(campanha),
          },
        ];
      case EstadoCampanhaENUM.Concluída:
      case EstadoCampanhaENUM.Sucesso:
        return [
          ...baseActions,
          {
            label: 'Exportar Comprovativo de Arrecadação',
            icon: 'pi pi-book',
            command: () => this.exportarComprovativoArrecadacaoFundo(campanha),
          },
          {
            label: 'Exportar Relatório da Campanha',
            icon: 'pi pi-chart-bar',
            command: () => this.openModalFilter(campanha),
          },
          // {
          //   label: 'Exportar Comprovativo de Doação',
          //   icon: 'pi pi-book',
          //   command: () => this.exportarComprovativoDoacaoFundo(campanha),
          // },
        ];

      default:
        return baseActions;
    }
  }

  showDialogRejeit(campanha: any) {
    this.showRejeitCampanha = true;
  }

  // Colocar a campanha em rascunho -- Estado 1
  ColocarCampanhaRascunho(campanha: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja colocar a campanha em rascunho?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, colocar',
      },
      accept: () => {
        const id = campanha?.id;
        const estado = '1';
        this.loading = true;

        this.campanhaService.updateStatus(id, estado).subscribe({
          next: (res) => {
            if (res.retorno.codigo === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: getResponseMessage(res, 'Campanha colocada em rascunho com sucesso!'),
                life: 5000,
              });
              this.getAllCampanhas();
              this.loading = false;
            } else {
              this.messageService.add({
                severity: 'warn',
                summary: 'Aviso',
                detail:
                  res.retorno.mensagem ||
                  'Falha ao colocar a campanha em rascunho!',
                life: 5000,
              });
            }
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: getResponseMessage(err, 'Ocorreu um erro ao colocar a campanha em rascunho'),
              life: 5000,
            });
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  // Publicar campanha -- Estado 3
  publicarCampanha(campanha: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja publicar esta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Publicar',
      },
      accept: () => {
        const id = campanha?.id;
        const estado = '4';
        this.loading = true;

        this.campanhaService.updateStatus(id, estado).subscribe({
          next: (res) => {
            if (res.retorno.codigo === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: getResponseMessage(res, 'Campanha publicada com sucesso!'),
                life: 5000,
              });
              this.getAllCampanhas();
              this.loading = false;
            } else {
              this.messageService.add({
                severity: 'warn',
                summary: 'Aviso',
                detail: res.retorno.mensagem || 'Falha ao publicar a campanha!',
                life: 5000,
              });
            }
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: getResponseMessage(err, 'Ocorreu um erro ao publicar a campanha'),
              life: 5000,
            });
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  // Supender campanha -- Estado 5
  suspenderCampanha(campanha: any) {
    this.showDialogSuspend = true;
    this.campanhaID = campanha.id;
  }

  // Excluir campanha -- Permanente
  excluirCampanha(campanha: any) {
    this.confirmationService.confirm({
      message:
        'Tem certeza que deseja eliminar esta campanha?. Esta ação é irreversível?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Eliminar',
      },
      accept: () => {
        const id = campanha?.id;
        this.loading = true;

        this.campanhaService.delete(id).subscribe({
          next: (res) => {
            if (res.retorno.codigo === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: getResponseMessage(res, 'Campanha eliminada com sucesso!'),
                life: 5000,
              });
              this.getAllCampanhas();
              this.loading = false;
            } else {
              this.messageService.add({
                severity: 'warn',
                summary: 'Aviso',
                detail:
                  res.retorno.mensagem ||
                  'Ocorreu um erro ao eliminar a campanha',
                life: 5000,
              });
              this.loading = false;
            }
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: getResponseMessage(err, 'Ocorreu um erro ao eliminar a campanha'),
              life: 5000,
            });
            this.loading = false;
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
        this.loading = false;
      },
    });
  }

  // Destacar campanha
  DestacarCampanha(campanha: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja destacar esta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Destacar',
      },
      accept: () => {
        this.loading = true;

        const params = {
          id: 0,
          campanhaID: campanha.id,
        };

        this.campanhaDestaqueService.store(params).subscribe({
          next: (res) => {
            this.loading = false;
            if (res.retorno.codigo === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Campanha destacada com sucesso!',
                life: 5000,
              });
              setTimeout(() => {
                this.getAllCampanhas();
              }, 5500);
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Falha',
                detail:
                  `${res.retorno.mensagem}` ||
                  'Esta campanha não pod ser destacada',
                life: 5000,
              });
            }
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao destacar a campanha',
              life: 5000,
            });
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  // controle de menus
  openedMenu: Menu | null = null;

  setOpenedMenu(menu: Menu) {
    if (this.openedMenu && this.openedMenu !== menu) {
      this.openedMenu.hide();
    }
    this.openedMenu = menu;
  }

  clearOpenedMenu() {
    this.openedMenu = null;
  }

  @HostListener('document:click')
  onDocumentClick() {
    if (this.openedMenu) {
      this.openedMenu.hide();
      this.openedMenu = null;
    }
  }

  // Exportar relatorio
  openModalFilter(campanha: any) {
    this.showModalFiter = true;
    this.campanhaSelecionada = campanha;
  }

  exportarRelatorio() {
    this.loadFilters = true;

    const filters = {
      CampanhaID: this.campanhaSelecionada?.id,
      ValorApoio: this.formFilter.get('ValorApoio')?.value || '',
      EstadoApoioENUM: this.formFilter.get('EstadoApoioENUM')?.value || '',
      Ativo: this.formFilter.get('Ativo')?.value || '',
    };

    this.documentoService.exportComprovativoApoio(filters).subscribe({
      next: (res: any) => {
        // Download do arquivo
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `relatorio_${this.campanhaSelecionada?.id || 'campanha'}.pdf`;
        a.click();
        globalThis.URL.revokeObjectURL(url);

        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Relatório exportado com sucesso!',
          life: 5000,
        });
        this.loadFilters = false;
        this.closeModalFilter();
      },

      error: (err: Error) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao exportar o relatório',
          life: 5000,
        });
        this.loadFilters = false;
        this.closeModalFilter();
      },
    });
  }

  closeModalFilter() {
    this.showModalFiter = false;
    this.loadFilters = false;
    this.formFilter.reset();
    this.campanhaSelecionada = null;
  }

  exportarComprovativoArrecadacaoFundo(campanha: any) {
    this.loading = true;
    const id = campanha?.id;
    this.documentoService.exportComprovativoArrecadacaoFundo(id).subscribe({
      next: (res: any) => {
        // Download do arquivo
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Comprovativo_${this.campanhaSelecionada?.id || 'campanha'}.pdf`;
        this.loading = false;
        a.click();
        globalThis.URL.revokeObjectURL(url);

        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Comprovativo exportado com sucesso!',
          life: 5000,
        });
      },

      error: (err: Error) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao exportar o comprovativo',
          life: 5000,
        });
        this.loading = false;
      },
    });
  }

  exportarComprovativoDoacaoFundo(campanha: any) {
    const id = campanha?.id;
    this.documentoService.exportComprovativoDoacaoFundo(id).subscribe({
      next: (res: any) => {
        // Download do arquivo
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Comprovativo_Doacao_${this.campanhaSelecionada?.id || 'campanha'}.pdf`;
        a.click();
        globalThis.URL.revokeObjectURL(url);

        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Comprovativo de Doação exportado com sucesso!',
          life: 5000,
        });
      },

      error: (err: Error) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao exportar o comprovativo de Doação',
          life: 5000,
        });
      },
    });
  }

  reembolsarApoios(campanha: any) {
    const id = campanha?.id;
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja reembolsar os apoios desta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Reembolsar',
      },
      accept: () => {
        this.campanhaService.reembolsarApoios(id).subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Apoios reembolsados com sucesso!',
              life: 5000,
            });
          },

          error: (err: Error) => {
            console.error(err);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao reembolsar os apoios',
              life: 5000,
            });
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  selecionarRecompensa(recompensa: any) {
    this.recompensaSelecionada = recompensa;

    const controle = this.formApoioManual.get('ValorApoio');

    controle?.setValue(recompensa.valor);
    controle?.disable();
  }

  getAllUsers() {
    this.utilizadorService.list({ pageSize: 10000 }).subscribe({
      next: (res) => {
        this.utilizadoresList = res.data.map((user: any) => ({
          label: user.userName,
          value: user.id,
        }));
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao carregar os utilizadores',
          life: 5000,
        });
      },
    });
  }

  openApoioManual(campanha: any) {
    this.campanhaSelecionada = campanha;
    this.campanhaID = campanha?.id;
    this.showDialogApoioManual = true;
    if (this.campanhaSelecionada.tipoFinanciamentoENUM === 3) {
      this.IsrecompensaCampanha = true;
    }

    if (this.IsrecompensaCampanha) {
      this.formApoioManual.get('ValorApoio')?.clearValidators();
      this.formApoioManual.get('ValorApoio')?.disable();
    } else {
      this.formApoioManual
        .get('ValorApoio')
        ?.setValidators([Validators.required]);
      this.formApoioManual.get('ValorApoio')?.enable();
    }
  }

  closeDialogApoioManual() {
    this.showDialogApoioManual = false;
    this.formApoioManual.reset();
    this.campanhaID = null;
    this.campanhaSelecionada = null;
    this.recompensaSelecionada = null;
    this.isDepositoApoio = false;
    this.isTransferenciaApoio = false;
  }

  SubmitApoioManual() {
    if (this.formApoioManual.invalid) {
      this.formApoioManual.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Formulário inválido',
        detail:
          'Por favor, preencha todos os campos obrigatórios corretamente.',
        life: 5000,
      });
      return;
    }

    if (this.IsrecompensaCampanha && !this.recompensaSelecionada) {
      this.messageService.add({
        severity: 'error',
        summary: 'Recompensa não selecionada',
        detail: 'Por favor, selecione uma recompensa para continuar.',
        life: 5000,
      });
      return;
    }

    this.loading = true;
    const params = {
      campanhaID: this.campanhaSelecionada?.id,
      utilizadorID: this.formApoioManual.get('utilizadorID')?.value,
      utilizadorResponsavelTransacaoID: this.userService.getUserId(),
      isDeposito: this.isDepositoApoio,
      isTransferencia: this.isTransferenciaApoio,
      ValorApoio: this.formApoioManual.get('ValorApoio')?.value,
      termoEmprestimoID: 0,
      recompensaID: this.IsrecompensaCampanha
        ? this.recompensaSelecionada.id
        : 0,
    };

    this.apoioService.apoioManual(params).subscribe({
      next: (res) => {
        if (res.retorno.codigo === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Apoio manual adicionado com sucesso!',
            life: 5000,
          });
          this.closeDialogApoioManual();
          this.getAllCampanhas();
          this.loading = false;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Falha',
            detail:
              `${res.retorno.mensagem}` ||
              'Não foi possível adicionar o apoio manual',
            life: 5000,
          });
          this.loading = false;
        }
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao adicionar o apoio manual',
          life: 5000,
        });
        this.loading = false;
      },
    });
  }
}
